// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_ht","advertCardNum":"c-a_hu"};